module.exports = __webpack_public_path__ + "static/54-a7777f9ee77c94589be20afcfd9cff68.jpg";